export default {
  "content": "<g clip-path=\"url(#clip0_431_53583)\"><path d=\"M10.534 0H2.438a.84.84 0 00-.843.84v11.32a.84.84 0 00.843.84h8.1a.84.84 0 00.838-.84V.84a.84.84 0 00-.84-.84zM6.5 12.188a.812.812 0 110-1.625.812.812 0 010 1.624zM9.75 9.45a.299.299 0 01-.3.299H3.55a.3.3 0 01-.3-.299V1.924a.299.299 0 01.3-.299H9.45a.299.299 0 01.299.299v7.527z\" fill=\"#fff\"/></g><defs><clipPath id=\"clip0_431_53583\"><path fill=\"#fff\" d=\"M0 0h13v13H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "13",
    "height": "13",
    "viewBox": "0 0 13 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};